export const RESET_MODAL = 'RESET_MODAL';
export const SELECT_ACTION = 'SELECT_ACTION';
export const SET_VALUES = 'SET_VALUES';
export const TOGGLE_AUTOCOMPLETE = 'TOGGLE_AUTOCOMPLETE';
export const TOGGLE_MODAL = 'TOGGLE_MODAL';
